import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { DynamicFormsService } from '../../services/dynamic-forms/dynamic-forms.service';
import { BaseInputDirective } from '../base-input.directive';
import { FormInfoService } from '../../services/dynamic-forms/form-info.service';
import { ErrorService } from '../../services/form-utility/error.service';
import { ErrorDefinition } from '../../models/error-definition';
import { DynamicFormLoadDirective } from '../../directives/dynamic-form-structural.directive';
import { Optional } from '@angular/core';

@Component({
  selector: 'app-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class CheckboxInputComponent extends BaseInputDirective implements OnInit {
  @Input() hideReadOnlyNo: boolean = false;

  // when increasing checkbox size,
  // update x and y translate to fit in hover state.
  @Input() transformSize: number = 1;
  @Input() translateX: string = '0px';
  @Input() translateY: string = '0px';

  constructor(
    formInfoService: FormInfoService,
    dynamicFormsService: DynamicFormsService,
    errorService: ErrorService,
    @Optional()
    dynamicFormDirective: DynamicFormLoadDirective,
  ) {
    super(formInfoService, dynamicFormsService, errorService, dynamicFormDirective);
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.formControl.value === null) {
      this.formControl.patchValue(false);
    }
    document.documentElement.style.setProperty('--check-box-scale', this.transformSize.toString());
    document.documentElement.style.setProperty('--translate-x', this.translateX);
    document.documentElement.style.setProperty('--translate-y', this.translateY);
  }

  getErrorDefinitions(): ErrorDefinition[] {
    return this.errorService.getGenericBoolErrors(this.formControl, this.fgInfo);
  }
}
